define('modules/editor/models/property_groups/border',['require','exports','module','./base'],function(require, exports, module){
  "use strict";
  var BasePropertyGroup = require("./base");
  module.exports = BasePropertyGroup.extend({
    /**
    NOTE
    This some property group must handle "inside borders"
    and "outside borders". It will be rendered using CSS
    border property, and "box-sizing" will control its position.
    **/
    name: "border",
    properties: [
      "type", //none solid dashed ...
      "width", //number (of pixels)
      "color", //hex value
      "position", //in | out
      "top", //boolean
      "bottom", //boolean
      "left", //boolean
      "right", //boolean
      "radius" //number
    ],
    generateStyles: function($el, id){
      var width = this.get("width") + "px",
           boxSizing = this.get("position") === "in" ?
             "border-box" : "content-box";
      return [{
        selector: "#" + id,
        rules: {
          "border-style": this.get("type"),
          "border-color": this.get("color"),
          "border-radius": (this.get("radius") || 0) + "px",
          "border-top-width": !!this.get("top") ? width : "0",
          "border-bottom-width": !!this.get("bottom") ? width  : "0",
          "border-left-width": !!this.get("left") ? width : "0",
          "border-right-width": !!this.get("right") ? width : "0",
          "box-sizing": boxSizing
        }
      }];
    },
    // applyStyles: function($el){
    //   var width = this.get("width") + "px",
    //       boxSizing = this.get("position") === "in" ?
    //         "border-box" : "content-box";
    //   $el
    //     .css("borderStyle", this.get("type"))
    //     .css("borderColor", this.get("color"))
    //     .css("borderRadius", this.get("radius") + "px")
    //     .css("borderTopWidth", this.get("top") ? width : "0px")
    //     .css("borderBottomWidth", this.get("bottom") ? width : "0px")
    //     .css("borderLeftWidth", this.get("left") ? width : "0px")
    //     .css("borderRightWidth", this.get("right") ? width : "0px")
    //     .css("boxSizing", boxSizing);
    // },
    validators: {
      width: function(attrs){
        var value = attrs.width,
            number = parseInt(value);
        return this.isInteger(value) && number >= 0 && number <= 20;
      },
      radius: function(attrs){
        var value = attrs.radius,
            number = parseInt(value);
        return this.isInteger(value) && number >= 0 && number <= 20;
      }
    }
  });
});
